import { Button } from '@/components/common/Button';
import { FlexCol } from '@/components/common/Flex';
import Modal from '@/components/common/modals/Modal';
import { BigHeader, Paragraph } from '@/components/common/Typography';
import ModalManager, { useModal } from '@/components/ModalManager';
import { useTrackModalShown } from '@/services/analytics/useTracking';
import dynamic from 'next/dynamic';
import successAnimation from '../../common/successLottie.json';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

export const showIdvSuccessModal = () => ModalManager.show(IdvSuccessModal, {});

export const IdvSuccessModal = ModalManager.create(() => {
    useTrackModalShown('IDV Success');

    const modal = useModal();

    return (
        <Modal
            size="4xl"
            isOpen={modal.visible}
            scrollBehavior="inside"
            isCentered={false}
            isFullScreen
            onClose={modal.hide}
            closeOnOverlayClick={false}
        >
            <FlexCol align="center" justify="center" gap={6} p={120}>
                <Lottie animationData={successAnimation} loop={false} />
                <BigHeader>
                    Your investment account will be opened shortly!
                </BigHeader>
                <Paragraph color="textMuted">
                    Your Plenty account is opened at BNY Mellon | Pershing, one
                    of the largest custodians in the world. They&apos;ll review
                    the application and we usually hear back within 1-3 business
                    days.
                </Paragraph>
                <Button
                    onClick={modal.remove}
                    onClickEvent="Finish IDV Button Clicked"
                    mt={4}
                >
                    Finish
                </Button>
            </FlexCol>
        </Modal>
    );
});
